import { Typography } from '@mui/material';

import { styled } from '@mui/system';

export const FieldHeadline = styled(Typography)`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: ${(props) => props.theme.palette.common.white};
`;
